import React, { Component } from 'react';
import axios from 'supports/api';
import { ButtonGroup, Button } from 'reactstrap';
import Select from 'react-select';

class AdminFinanceMasterTujuanPenerimaanRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      tujuanPenerimaan: this.props.tujuanPenerimaan,
      accountMaster: {
        value: this.props.accountMasterId,
        label: this.props.accountMaster,
      },
    };
  }

  handleInput(type, input) {
    this.setState({ [type]: input });
  }

  handleAccountMaster = (selectedOption) => {
    this.setState({ accountMaster: selectedOption });
  };

  handleEdit() {
    this.setState({ isEditing: true });
  }

  handleDelete() {
    if (window.confirm('Apakah anda yakin ingin menghapus data ini ?')) {
      axios
        .delete(`/masterTujuanPenerimaan/delete/${this.props.id}`)
        .then((res) => {
          alert('Data telah berhasil dihapus');
          console.log(res);
          this.props.refreshList();
        })
        .catch((err) => {
          console.log(err);
          alert(err.message);
        });
    }
  }

  handleCancel() {
    this.setState({
      isEditing: false,
      tujuanPenerimaan: this.props.tujuanPenerimaan,
      accountMaster: {
        value: this.props.accountMasterId,
        label: this.props.accountMaster,
      },
    });
  }

  handleSave = () => {
    if (this.state.tujuanPenerimaan !== '') {
      if (this.state.accountMaster !== '') {
        if (window.confirm('Apakah anda yakin ingin mengupdate data ini ?')) {
          const data = {
            tujuanPenerimaan: this.state.tujuanPenerimaan,
            accountMasterId: this.state.accountMaster.value,
          };

          axios
            .put(`/masterTujuanPenerimaan/update/${this.props.id}`, data)
            .then((res) => {
              alert('Data telah berhasil diperbaharui');
              // console.log(res)
              // data = {
              //     tujuanPenerimaan: this.state.tujuanPenerimaan,
              //     accountMaster: this.state.accountMaster,
              //     accountMasterId: this.state.accountMaster.value
              // }
              // this.props.update(this.props.index, data)

              this.setState({
                isEditing: false,
              });
              this.props.refreshList();
            })
            .catch((err) => {
              console.log(err);
              alert(err.message);
            });
        }
      }
    }
  };

  componentWillReceiveProps(nextProps) {
    // console.log(this.props.accountMaster, nextProps.accountMaster)
    // this.setState({
    //     tujuanPenerimaan: this.props.tujuanPenerimaan,
    //     accountMaster: { value: nextProps.accountMasterId, label: nextProps.accountMaster }
    // })
    // var data = {
    //     tujuanPenerimaan: this.state.tujuanPenerimaan,
    //     accountMaster: this.state.accountMaster,
    //     accountMasterId: this.state.accountMaster.value
    // }
    // this.props.update(this.props.index, data)
  }

  render() {
    if (!this.state.isEditing) {
      return (
        <tr>
          <th>{this.props.number}</th>
          <td>{this.state.tujuanPenerimaan}</td>
          <td>{this.state.accountMaster.label}</td>
          <td>
            <ButtonGroup>
              <Button
                className="btn btn-secondary"
                onClick={() => {
                  this.handleEdit();
                }}
              >
                Edit
              </Button>
              <Button
                className="btn btn-danger"
                onClick={() => this.handleDelete()}
              >
                Delete
              </Button>
            </ButtonGroup>
          </td>
        </tr>
      );
    }
    return (
      <tr>
        <th>{this.props.number}</th>
        <td>
          <input
            type="text"
            value={this.state.tujuanPenerimaan}
            className="form-control"
            placeholder="Input Tujuan Penerimaan"
            ref="tujuanPenerimaan"
            onChange={() =>
              this.handleInput(
                'tujuanPenerimaan',
                this.refs.tujuanPenerimaan.value,
              )
            }
          />
        </td>
        <td>
          <Select
            value={this.state.accountMaster}
            options={this.props.listAccountMaster}
            onChange={this.handleAccountMaster}
            id="selectAccountMasterItem"
          />
        </td>
        <td>
          <ButtonGroup>
            <Button
              className="btn btn-secondary"
              onClick={() => {
                this.handleCancel();
              }}
            >
              Cancel
            </Button>
            <Button className="btn btn-info" onClick={() => this.handleSave()}>
              Save
            </Button>
          </ButtonGroup>
        </td>
      </tr>
    );
  }
}

export default AdminFinanceMasterTujuanPenerimaanRow;
